export default __webpack_public_path__ + "static/article-consolidating-debt-what-you-need-to-know-19aa6e439bc31dde79c1d7dfadabdd3d.jpg";